import { Component } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-contacts-destiny-list',
	templateUrl: './contacts-destiny-list.component.html',
	styleUrls: ['./contacts-destiny-list.component.css'],
})
export class ContactsDestinyListComponent extends ListComponent {
	protected apiUrl = 'contacts_destiny';
	protected apiType = 'bag';
	codebook;
	title: string;
	tableRows = [{ id: 'destiny', name: 'Przeznaczenie' }];

	filters = {
		limit: 9999,
	};

	protected loadBefore(): void {
		this.bag.get('/codebook/11/', (result, error) => {
			this.codebook = result;

			this.title = `Słowniki ->  ${this.codebook.name}`;
			this.loadData();
		});
	}
}
